/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommissionParitaireGridDto } from './CommissionParitaireGridDto';
import {
    CommissionParitaireGridDtoFromJSON,
    CommissionParitaireGridDtoFromJSONTyped,
    CommissionParitaireGridDtoToJSON,
} from './CommissionParitaireGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface CommissionParitaireGridDtoPaginatedResults
 */
export interface CommissionParitaireGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof CommissionParitaireGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CommissionParitaireGridDto>}
     * @memberof CommissionParitaireGridDtoPaginatedResults
     */
    results?: Array<CommissionParitaireGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof CommissionParitaireGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the CommissionParitaireGridDtoPaginatedResults interface.
 */
export function instanceOfCommissionParitaireGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CommissionParitaireGridDtoPaginatedResultsFromJSON(json: any): CommissionParitaireGridDtoPaginatedResults {
    return CommissionParitaireGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function CommissionParitaireGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionParitaireGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(CommissionParitaireGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function CommissionParitaireGridDtoPaginatedResultsToJSON(value?: CommissionParitaireGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(CommissionParitaireGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

